<template>
    <section>
        <div class="d-flex justify-content-center" >
            <div class="cards ligacao" @click="statusSelected('ligacao')">
                <h4>Ligação</h4>
                <hr class="style-two">
                <h5>{{call}}</h5>
            </div>

            <div class="cards pausa" @click="statusSelected('pausa')">
                <h4> Pausa </h4>
                <hr class="style-two">
                <h5>{{pause}}</h5>
            </div>

            <div class="cards ativo" @click="statusSelected('ativo')">
               <h4> Ativo </h4>
               <hr class="style-two">
               <h5>{{active}}</h5>
            </div>

            <div class="cards deslogado" @click="statusSelected('deslogado')">
                <h4> Deslogado </h4>
                <hr class="style-two">
                <h5>{{logoff}}</h5>
            </div>

            <div class="cards todos" @click="statusSelected('*')">
                <h4> Todos </h4>
                <hr class="style-two">
                <h5>{{ todos }}</h5>
            </div>
        </div>

		<div class="select-queue">
			<select class="form-control form-control-sm queue-select" v-model="changeSetor">
				<option value="*" selected>Todas</option>

				<option v-for="(setor, index) in setores" :key="index" :value="setor">
					{{setor}}
				</option>

			</select>


			<select class="form-control form-control-sm queue-select subSetor" v-if="changeSetor != '*'" v-model="changeSubSetor">
				<option value="*" selected>Todas</option>

				<option v-for="(setor, index) in subSetores[changeSetor]" :key="index" :value="setor">
					{{setor}}
				</option>

			</select>
		</div>

    </section>
</template>

<script>


export default {
    data: function(){
        return {
			setores: [],
			subSetores: [],
			changeSetor: "*",
			changeSubSetor: "*"
        }
    },
	props:['call', 'pause', 'active', 'logoff', 'todos'],
	watch:{
		changeSetor(newSetor){
			this.changeSubSetor = '*';

			this.$emit('changeSetor', newSetor);
		},
		changeSubSetor(newSubSector){

			this.$emit('changeSubSetor', newSubSector);

		}
	},
    methods: {
		statusSelected(stat){
			this.$emit('statusSelected', stat);
		}
    },
    mounted(){

		axios.get('/realtime/distinctSectors').then(data => {

			data.data.map(el => {
				if(!this.subSetores[el.sector_name]){
					this.subSetores[el.sector_name] = [];
				}
				this.subSetores[el.sector_name].push(el.alias_name);
			});

			this.setores = Object.keys(this.subSetores);

		});
    }

}
</script>

<style scoped>

    .cards{
        border-radius: 4px;
        align-content: center;
        color:white;
        height:7em;
        width: 11em;
        text-align: center;
        margin-right: 1em;
        padding: 0.5em;
        margin-bottom: 2em;
        cursor:pointer;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    }

    .cards:hover {
    	box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }

    .ligacao {
        background-color: #16a085;
    }

    .pausa{
        background-color: #f39c12;
    }

    .ativo{
        background-color: #17a2b8;

    }
    .deslogado{
        background-color: grey;
    }
    .todos{
        background-color: #a1a1a1;
    }
    hr.style-two{
        margin-top:0px;
        border: 0;
        height: 1px;
        background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0));
    }

	.select-queue{
		display: flex;
		justify-content: center;
		margin-bottom: 5px;
	}

	.queue-select{
		width: 10%;
		border-radius: 0.25em !important; /* ALGUEM Tira esse app.scss SOCORRO*/
	}

	.subSetor{
		margin-left: 2em;
	}
</style>
